import environment from "@irati/utils/env"
import {STAGING, PRODUCTION} from "@irati/utils/constants/environment"

type Env = typeof STAGING | typeof PRODUCTION

const flexiPerkTag = {
  [STAGING]: {
    id: "681a233b-2ad1-4084-9540-be86f6976e62",
    url: "flexi-perks"
  },
  [PRODUCTION]: {
    id: "3f5eb74d-517a-48f9-bd8e-f11a68c54c02",
    url: "flexi-perks"
  }
}
export const getFlexiPerkTag = () => {
  const env = environment.ENVIRONMENT_NAME as unknown as Env
  switch (env) {
    case PRODUCTION:
      return flexiPerkTag[PRODUCTION]

    default:
      return flexiPerkTag[STAGING]
  }
}
